import { Dict } from "./@types/Dict";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type As<Props = any> = React.ElementType<Props>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DistributiveOmit<T, K extends keyof any> = T extends any
  ? Omit<T, K>
  : never;

export type AsComponentProp<C extends As, Props = Dict> = Props & {
  as?: C;
} & DistributiveOmit<React.ComponentPropsWithoutRef<C>, keyof Props | "as">;

export type AsRef<C extends React.ElementType> =
  React.ComponentPropsWithRef<C>["ref"];

export type MergeWithAs<
  ComponentProps extends object,
  AsProps extends object,
  AdditionalProps extends object = Dict,
  AsComponent extends As = As,
> = AdditionalProps &
  Omit<ComponentProps, keyof AdditionalProps | "as"> &
  Omit<AsProps, keyof ComponentProps | keyof AdditionalProps | "as"> & {
    as?: AsComponent;
  };

export type ComponentWithAs<
  Component extends As,
  Props extends object = Dict,
> = <AsComponent extends As = Component>(
  props: MergeWithAs<
    React.ComponentProps<Component>,
    React.ComponentProps<AsComponent>,
    Props,
    AsComponent
  > & {
    ref?: AsRef<AsComponent>;
  },
) => React.JSX.Element | null;
